import { AD_CLIENT, isLiveAdEnvironment } from '@/config/ads';

export class AdSenseService {
  constructor({ isEligible = () => false, isLive = () => isLiveAdEnvironment(
    window.location.hostname, import.meta.env.PROD,
  ) } = {}) {
    this.isEligible = isEligible;
    this.isLive = isLive;
    this.loadPromise = null;
    this.loaded = false;
    this.requested = false;
    this.pushed = new WeakSet();
  }

  shouldShowAds() {
    return typeof window !== 'undefined' && this.isLive() && this.isEligible();
  }

  // A single bounded attempt per document. Blockers never start retry loops.
  ensureLoaded() {
    if (!this.shouldShowAds()) return Promise.resolve(false);
    if (this.loadPromise) return this.loadPromise;
    this.requested = true;
    this.loadPromise = new Promise(resolve => {
      const script = document.createElement('script');
      script.id = 'indiefy-adsense';
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`;
      const finish = loaded => {
        clearTimeout(timeout);
        script.onload = script.onerror = null;
        this.loaded = loaded;
        if (!loaded) script.remove();
        resolve(loaded);
      };
      const timeout = setTimeout(() => finish(false), 8000);
      script.onload = () => finish(true);
      script.onerror = () => finish(false);
      try { document.head.appendChild(script); } catch { finish(false); }
    });
    return this.loadPromise;
  }

  pushAd(element) {
    if (!this.shouldShowAds() || !this.loaded || !element?.isConnected
      || element.getBoundingClientRect().width <= 0
      || this.pushed.has(element) || element.hasAttribute('data-adsbygoogle-status')) {
      return false;
    }
    // Track DOM instances, not slot IDs: a departing view cannot clear a new ad.
    this.pushed.add(element);
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      return true;
    } catch {
      return false;
    }
  }
}

export default new AdSenseService();
